const translates = {
  'Sellers': 'فروشنده‌ها',
  'Edit Seller': 'ویرایش فروشنده',
  'Mobile Number': 'شماره موبایل',
  'Mobile': 'موبایل',
  'Role': 'نقش',
  'Create Date': 'تاریخ ساخت',
  'Store': 'فروشگاه',
  'Warranty Number': 'شماره گارانتی',
  'Serial Number': 'شماره سریال',
  'Seller': 'فروشنده',
  'Customer': 'خریدار',
  'customer': 'خریدار',
  'cs': 'کال سنتر',
  'sa': 'ادمین',
  'store_manager': 'مدیر فروشگاه',
  'Amount': 'مقدار',
  'Status': 'وضعیت',
  'Done': 'تکمیل',
  'Name': 'نام',
  'Last Name': 'نام خانوادگی',
  'City': 'شهر',
  'Dashboard': 'داشبورد',
  'Users': 'کاربران',
  'Customers': 'خریدارها',
  'Stores': 'فروشگاه‌ها',
  'Warranties': 'گارانتی‌ها',
  'Warranty Activation': 'فعال‌سازی گارانتی',
  'Warranty Reports': 'گزارش گارانتی‌ها',
  'Transactions': 'تراکنش‌ها',
  'Create': 'افزودن',
  'Insurances': 'شرکت‌های بیمه',
  'Customer Name': 'نام خریدار',
  'Customer Mobile': 'شماره خریدار',
  'Customer Number': 'شماره خریدار',
  'Customer National Id': 'کد ملی خریدار',
  'Date From': 'از تاریخ',
  'Date To': 'تا تاریخ',
  'Search': 'جستجو',
  'Insurance': 'بیمه',
  'Warranty': 'گارانتی',
  'Actions': 'عملکردها',
  'Address': 'آدرس',
  'Export CSV': 'خروجی اکسل',
  'Email': 'ایمیل',
  'Filters': 'فیلترها',
  'Website': 'وبسایت',
  'Phone Number': 'شماره تلفن',
  'Phones': 'گوشی‌ها',
  'Phone': 'گوشی‌',
  'Profile Pic': 'عکس پروفایل',
  'Choose Image': 'انتخاب عکس',
  'Is Manager?': 'مدیر فروشگاه؟',
  'Password': 'رمز عبور',
  'Login': 'ورود',
  'User': 'کاربر',
  'Submit': 'ثبت',
  'Brand': 'برند',
  'Model': 'مدل',
  'Pay Date': 'تاریخ پرداخت',
  'Expire Date': 'تاریخ انقضا',
  'Vat': 'مالیات',
  'Product Price': 'قیمت دستگاه',
  'Product Price Toman': 'قیمت دستگاه به تومان',
  'Price': 'قیمت گارانتی',
  'Warranty Price': 'قیمت گارانتی',
  'Store Commission': 'کمیسیون فروشگاه',
  'Commission': 'کمیسیون',
  'Activated': 'فعال‌شده',
  'Confirm Password': 'تایید رمز عبور',
  'Set New Password': 'ثبت رمز عبور',
  'Warranty Cards': 'کارت های گارانتی',
  'row': 'ردیف',
  'deactivate': 'غیرفعال کردن',
  'confirm': 'تایید',
  'Yes': 'بله',
  'No': 'خیر',
  'deleted': 'غیر فعال',
  'activate': 'فعال کردن',
  'Confirm': 'تایید',
  'Add New Seller': 'افزودن فروشنده جدید',
  'Are you sure you want to delete': 'آیا مطمئن هستید که میخواهید غیرفعال کنید؟',
  'Are you sure you want to activate': 'آیا مطمئن هستید که میخواهید فعال کنید؟',
  'successfully edited': 'با موفقیت ویرایش شد',
  'successfully added': 'با موفقیت اضافه شد',
  'something went wrong': 'مشکلی پیش آمده است',
  'Code': 'کد ورود',
  'Forgot password?': 'رمز عبور خود را فراموش کرده‌اید؟',
  'Service': 'سرویس',
  'Theft': 'سرقت',
  'Exchange': 'تعویض',
  'Exchange With Old': 'تعویض گوشی کارکرده',
  'Exchange Unrepairable': 'تعویض مورد غیرقابل تعمیر',
  'Exchange Thirty Days': 'تعویض ۳۰ روزه',
  'Repaire': 'تعمیرات',
  'Expiration Date': 'تاریخ انقضا',
  'Factor Picture': 'عکس فاکتور',
  'Box Picture': 'عکس جعبه',
  'Monthly Sale': 'فروش این ماه شما',
  'Monthly Comission': 'درامد این ماه',
  'Total Comission': 'درآمد کل',
  'From Last Sale': 'از اخرین فروش',
  'Agency Requests': 'درخواست‌های نمایندگی',
  'Contact Requests': 'درخواست‌های تماس',
  'Total Sale': 'فروش کل',
  'My Cards': 'کارت های من',
  'Picture': 'عکس',
  'Request new card': 'درخواست کارت جدید',
  'count': 'تعداد',
  'Store Name': 'نام فروشگاه',
  'submit': 'ثبت',
  'Contract Image': 'عکس قرارداد',
  'Request sent successfully': 'درخواست با موفقیت ارسال شد',
  'Store Manager': 'مدیر فروشگاه',
  'Store Manager Name': 'نام مدیر فروشگاه',
  'Store Manager Last Name': 'نام خانوادگی مدیر فروشگاه',
  'Store Manager Mobile': 'موبایل مدیر فروشگاه',
  'Agent': 'معرف',
  'agent': 'معرف',
  'Agents': 'معرف‌ها',
  'Location': 'موقعیت',
  'Assign Card': 'اختصاص کارت',
  'Scan': 'اسکن',
  'Number of Stores': 'تعداد فروشگاه',
  'Something went wrong': 'مشکلی پیش آمده است',
  'Warranty assigned successfully': 'گارانتی با موفقیت اختصاص یافت',
  'Total Active': 'تعداد گارانتی های فعال شده',
  'Total Warranties This Month': 'تعداد گارانتی های فعال شده این ماه',
  'Total Warranties Today': 'تعداد گارانتی های فعال شده امروز',
  'Total Warranties': 'تعداد کل گارانتی‌های تخصیص یافته',
  'Total Active Stores': 'تعداد فروشگاه های فعال',
  'Total Stores': 'تعداد کل فروشگاه ها',
  'Card Requests': 'درخواست‌های کارت',
  'Account Number': 'شماره حساب',
  'Sheba Number': 'شماره شبا',
  'Sheba Verified': 'قرارداد شبا با بانک انجام شده',
  'Store already exists': 'فروشگاه قبلا ثبت شده است',
  'Finance': 'مالی',
  'Customer Support': 'کال سنتر',
  'Insurance Manager': 'مدیر بیمه',
  'Sales Manager': 'مدیر فروش',
  'Hamrahtel': 'همراه تل',
  'Super Admin': 'ادمین',
  'Stores Count': 'تعداد فروشگاه ها',
  'Warranties Count': 'تعداد گارانتی ها',
  'Active Warranties': 'گارانتی های فعال',
  'Store Bonus': 'بونوس فروشگاه',
  'Warranty Bonus': 'بونوس گارانتی',
  'Account Holder': 'نام دارنده حساب',
  'Contract Image Back': 'عکس پشت قرارداد',
  'Shop Id': 'شاپ کد',
  'Province': 'استان',
  'can use change': 'میتواند از سرویس تعویض استفاده کند',
  'wrong serial number': 'شماره سریال اشتباه است',
  'Total Active Stores This Month': 'تعداد فروشگاه های فعال شده این ماه',
  'Service Centers': 'مراکز خدماتی',
  'Banner': 'بنر',
  'Banners': 'بنرها',
  'Title': 'عنوان',
  'Link': 'لینک',
  'Active': 'فعال',
  'Image Url': 'عکس',
  'Inactive': 'غیرفعال',
};

export function translate(value) {
  return translates[value] || value
}
